import { render, staticRenderFns } from "./schoolPrinciple.vue?vue&type=template&id=34f4de12&scoped=true&"
import script from "./schoolPrinciple.vue?vue&type=script&lang=js&"
export * from "./schoolPrinciple.vue?vue&type=script&lang=js&"
import style0 from "./schoolPrinciple.vue?vue&type=style&index=0&id=34f4de12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4de12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VCol,VLayout,VRow,VSelect,VTextField})
